import { sendRequest } from "../../generated/api";

export async function getProductCount(fbToken: string) {
  const result = await sendRequest(fbToken)("ShopifyApiController_countProducts", {});
   return result.data;
 }